import { render, staticRenderFns } from "./DashboardSales.vue?vue&type=template&id=6a741d1e"
import script from "./DashboardSales.vue?vue&type=script&lang=js"
export * from "./DashboardSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports